var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.user.id)?_c('Loader',{attrs:{"text":"Ładowanie strony"}}):_vm._e(),(_vm.user.id)?_c('div',{staticClass:"container pt-4"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3 text-center"},[_c('h1',[_vm._v("Brak dostępu")]),_c('h5',[_vm._v("Nie masz dostępu do tego modułu")])])
}]

export { render, staticRenderFns }